import { render, staticRenderFns } from "./UpdateUsers.vue?vue&type=template&id=64c69374&scoped=true&"
import script from "./UpdateUsers.vue?vue&type=script&lang=js&"
export * from "./UpdateUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c69374",
  null
  
)

export default component.exports